<template>
  <!-- input de buscas -->
  <div class="container__input-busca">
    <img
      class="icone__lupa"
      src="/static/novomundosenai/imgs/icone-busca-lupa.svg"
      alt="icone busca lupa"
    />
    <input
      _filter_text_field
      class="input__busca"
      type="text"
      name="busca"
      v-model="word"
      id="ipt_busca"
      :placeholder="placeholder"
      @blur="wordChanged()"
      @keydown.enter.prevent.stop="wordChanged()"
    />
  </div>
  <!-- fim  input de buscas  -->
</template>

<script>
import { toRefs } from '@vue/reactivity'
import { useSearch } from '@/composables/useSearch.js'
export default {
  name: 'FilterInputFindByWord',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    searchWord: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const { searchWord } = toRefs(props)
    const { word } = useSearch()
    word.value = searchWord.value || ''

    function wordChanged() {
      const nextURL = `${window.location.protocol}//${window.location.host}/novo-busca/?search=${word.value}`
      const nextTitle = ''
      const nextState = { search: word.value }
      window.history.pushState(nextState, nextTitle, nextURL)
      window.history.replaceState(nextState, nextTitle, nextURL)
      context.emit('wordChanged')
    }

    return { word, wordChanged }
  },
}
</script>
